// Get current mindset
export const getSelecteMindset = (state) => {
  return state.selectedMindset
}
